// extracted by mini-css-extract-plugin
export default {"main":"Home_main__TeKM4","main_with_cards":"Home_main_with_cards__FDJ51","card":"Home_card__-vJdP","date":"Home_date__Sg311"};